import styles from './index.module.sass';
import GetPiCities from 'components/get-pi-cities';
import iconInfo from 'assets/info-outlined.svg';
import { helperUrl } from 'config';

const StreetParkingLayout = ({ children, cities = [], className, helpOnClick }) => {
  return (
    <div className={`${styles.layout} ${className}`}>
      <div className={styles.top}>{children}</div>
      <div className={styles.bottom}>
        {helpOnClick && (
          <a
            className={styles.help}
            href={`${helperUrl}/street-parking/autopay`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={helpOnClick}
          >
            自動繳費常見問題
            <img src={iconInfo} alt="info" />
          </a>
        )}
        {cities.length !== 0 && <GetPiCities cities={cities} />}
      </div>
    </div>
  );
};

export default StreetParkingLayout;
